import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const estados = [
  { id: 1, nombre: "Alta Doble Colegiación" },
  { id: 2, nombre: "Alta Jubilado Activo" },
  { id: 3, nombre: "Alta Nuevo Ingreso" },
  { id: 4, nombre: "Alta Reingreso" },
  { id: 5, nombre: "Alta Reingreso Procedente UE" },
  { id: 6, nombre: "Alta Traslado" },
];

const SelectEstado = ({ name, value, onChange }) => (
  <FormControl fullWidth>
    <InputLabel id={`${name}-label`}>Tipo de colegiación</InputLabel>
    <Select labelId={`${name}-label`} name={name} value={value} onChange={onChange}>
      {estados.map((estado) => (
        <MenuItem key={estado.id} value={estado.id}>
          {estado.nombre}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default SelectEstado;
